import WebApp from "../components/WebApp";

const GettingStarted = () => {
  return (
    <WebApp>
      <div>Getting Started</div>
    </WebApp>
  );
};


export default GettingStarted;